(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[\s_]+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  function uniqueId(base, used) {
    var id = base;
    var i = 2;
    while (used[id]) {
      id = base + '-' + i;
      i += 1;
    }
    used[id] = true;
    return id;
  }

  function escapeSelector(id) {
    if (window.CSS && typeof CSS.escape === 'function') {
      return CSS.escape(id);
    }
    return String(id).replace(/([^a-zA-Z0-9_-])/g, '\\$1');
  }

  function closeMobilePanel(sectionEl) {
    var toggle = sectionEl.querySelector('[data-toc-toggle]');
    var panel = sectionEl.querySelector('[data-toc-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  function buildToc(sectionEl) {
    var content = sectionEl.querySelector('[data-article-content]');
    var tocLists = sectionEl.querySelectorAll('[data-article-toc]');
    var tocRoots = sectionEl.querySelectorAll('[data-toc-root]');

    if (!content || !tocLists.length) return;

    var headings = content.querySelectorAll('h2');
    if (!headings.length) {
      tocRoots.forEach(function (root) {
        root.setAttribute('hidden', '');
      });
      tocLists.forEach(function (list) {
        list.innerHTML = '';
      });
      return;
    }

    tocRoots.forEach(function (root) {
      root.removeAttribute('hidden');
    });

    var usedIds = {};
    var itemsHtml = '';

    headings.forEach(function (heading) {
      var existingId = heading.getAttribute('id');
      var id =
        existingId && existingId.trim() !== ''
          ? existingId
          : uniqueId(slugify(heading.textContent), usedIds);

      if (!existingId || existingId.trim() === '') {
        heading.setAttribute('id', id);
      } else {
        usedIds[id] = true;
      }

      var label = heading.textContent.trim();
      itemsHtml +=
        '<li class="article-custom__toc-item tw-m-0">' +
        '<a class="article-custom__toc-link tw-inline-block tw-rounded-sm tw-px-2 tw-py-1 tw-text-[length:var(--smaller-text-size-2)] tw-leading-snug tw-text-[rgb(var(--body-text-color)/0.75)] tw-no-underline hover:tw-text-[rgb(var(--link-color))]" data-toc-target="' +
        id +
        '" href="#' +
        id +
        '">' +
        label.replace(/</g, '&lt;').replace(/>/g, '&gt;') +
        '</a></li>';
    });

    tocLists.forEach(function (list) {
      list.innerHTML = itemsHtml;
    });

    bindTocHighlight(sectionEl, headings);
  }

  function getHeaderOffset() {
    var headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--theme-header-height')
    );
    return Number.isFinite(headerHeight) ? headerHeight : 0;
  }

  function setActiveTocItem(sectionEl, activeId) {
    sectionEl.querySelectorAll('[data-toc-target]').forEach(function (link) {
      var isActive = link.getAttribute('data-toc-target') === activeId;
      link.classList.toggle('article-custom__toc-link--active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function bindTocHighlight(sectionEl, headings) {
    if (sectionEl.dataset.tocHighlightBound === 'true') return;
    sectionEl.dataset.tocHighlightBound = 'true';

    var ticking = false;
    var updateActiveHeading = function () {
      ticking = false;
      var offset = getHeaderOffset() + 32;
      var activeHeading = headings[0];

      headings.forEach(function (heading) {
        if (heading.getBoundingClientRect().top <= offset) {
          activeHeading = heading;
        }
      });

      if (activeHeading && activeHeading.id) {
        setActiveTocItem(sectionEl, activeHeading.id);
      }
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActiveHeading);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateActiveHeading();
  }

  function onSectionClick(event) {
    var sectionEl = event.currentTarget;

    var toggle = event.target.closest('[data-toc-toggle]');
    if (toggle && sectionEl.contains(toggle)) {
      var panel = sectionEl.querySelector('[data-toc-panel]');
      if (!panel) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;
      return;
    }

    var commentsLink = event.target.closest('[data-comments-anchor]');
    if (commentsLink && sectionEl.contains(commentsLink)) {
      var commentsTarget = document.getElementById('comments');
      if (!commentsTarget) return;
      event.preventDefault();
      var commentsY =
        commentsTarget.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 24;
      window.scrollTo({ top: Math.max(0, commentsY), behavior: 'smooth' });
      return;
    }

    var link = event.target.closest('[data-article-toc] a[href^="#"]');
    if (!link || !sectionEl.contains(link)) return;

    var id = link.getAttribute('href').slice(1);
    if (!id) return;

    var target =
      sectionEl.querySelector('[data-article-content] #' + escapeSelector(id)) ||
      document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    var targetY = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 24;
    window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
    closeMobilePanel(sectionEl);
  }

  function formatCount(value) {
    var num = Number(value);
    if (!Number.isFinite(num) || num < 0) return '—';
    return String(Math.floor(num));
  }

  function pickViewCount(payload) {
    if (!payload) return null;
    var data = payload.data != null ? payload.data : payload;
    if (Array.isArray(data)) {
      data = data[0];
    }
    if (!data || typeof data !== 'object') return null;
    if (data.view_count != null) return data.view_count;
    if (data.views != null) return data.views;
    return null;
  }

  function loadArticleViews(sectionEl) {
    var stats = sectionEl.querySelector('[data-article-stats]');
    if (!stats) return;

    var viewsEl = stats.querySelector('[data-views-count]');
    if (!viewsEl) return;

    var apiUrl = stats.getAttribute('data-views-api');
    var handle = stats.getAttribute('data-blog-handle');
    if (!apiUrl || !handle) return;

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'omit',
      body: JSON.stringify({
        customer_id: String(stats.getAttribute('data-customer-id') || 'guest'),
        blog_id: String(stats.getAttribute('data-blog-id') || ''),
        blog_title: stats.getAttribute('data-blog-title') || '',
        handle: handle
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('views request failed');
        return response.json();
      })
      .then(function (json) {
        viewsEl.textContent = formatCount(pickViewCount(json));
      })
      .catch(function () {
        viewsEl.textContent = '—';
      });
  }

  function bindSection(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.dataset.tocBound === 'true') {
      buildToc(sectionEl);
      loadArticleViews(sectionEl);
      return;
    }
    sectionEl.dataset.tocBound = 'true';
    sectionEl.addEventListener('click', onSectionClick);
    buildToc(sectionEl);
    loadArticleViews(sectionEl);
  }

  function initAll(scope) {
    if (scope && scope.matches && scope.matches('[data-article-custom]')) {
      delete scope.dataset.tocBound;
      bindSection(scope);
      return;
    }

    var root = scope || document;
    var sections = root.querySelectorAll('[data-article-custom]');
    sections.forEach(function (sectionEl) {
      bindSection(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target;
    if (!sectionEl) return;
    if (sectionEl.matches && sectionEl.matches('[data-article-custom]')) {
      initAll(sectionEl);
      return;
    }
    var nested = sectionEl.querySelector && sectionEl.querySelector('[data-article-custom]');
    if (nested) initAll(nested);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
